import { render } from "./DrinkProducts.vue?vue&type=template&id=1c98b74a&scoped=true&ts=true"
import script from "./DrinkProducts.vue?vue&type=script&lang=ts"
export * from "./DrinkProducts.vue?vue&type=script&lang=ts"

import "./DrinkProducts.vue?vue&type=style&index=0&id=1c98b74a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.21_vue@3.4.21_typescript@5.4.5__webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c98b74a"]])

export default __exports__